import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        blog: 'Blog',
        contact: 'Contact',
        bookAppointment: 'Book Appointment',
        emergency: 'Emergency'
      },
      hero: {
        welcome: '30 Years of Trusted ENT Care',
        subtitle: 'Expert consultation for Ear, Nose & Throat disorders in Biswanath, Assam',
        cta: 'Book Your Appointment',
        learnMore: 'Learn More'
      },
      about: {
        title: 'About Dr. N.C. Upadhyaya',
        subtitle: 'Chief ENT Consultant',
        description: 'Dr. N.C. Upadhyaya holds MBBS from Assam Medical College, Dibrugarh and DLO from Silchar Medical College, bringing over 30 years of specialized experience in Otorhinolaryngology. As a Retired SDMO of Biswanath and President of Indian Medical Association, Biswanath Branch, he founded Aarogya ENT Clinic to provide compassionate and comprehensive ENT care to the community.',
        experience: '30+ Years Experience',
        community: 'Serving the Community',
        expertise: 'Expert ENT Care'
      },
      services: {
        title: 'Our Services',
        subtitle: 'Comprehensive ENT Care Under One Roof',
        consultation: {
          title: 'ENT Consultation',
          description: 'Comprehensive evaluation and diagnosis of all ear, nose, and throat conditions'
        },
        endoscopy: {
          title: 'ENT Endoscopy',
          description: 'Advanced endoscopic examination for accurate diagnosis of ENT disorders'
        },
        waxRemoval: {
          title: 'Ear Wax Removal',
          description: 'Safe and painless syringing procedure for complete wax removal'
        },
        microscope: {
          title: 'Microscopic Examination',
          description: 'Detailed examination under microscope for precise diagnosis'
        },
        foreignBody: {
          title: 'Foreign Body Removal',
          description: 'Safe removal of foreign objects from ear, nose, and throat'
        },
        allergyTesting: {
          title: 'Allergy Testing',
          description: 'Comprehensive testing to identify allergens causing ENT problems'
        },
        vertigo: {
          title: 'Vertigo Assessment',
          description: 'Complete evaluation and treatment for vertigo and balance disorders'
        }
      },
      appointment: {
        title: 'Book Your Appointment',
        subtitle: 'Schedule your visit at Aarogya ENT Clinic',
        form: {
          name: 'Full Name',
          phone: 'Phone Number',
          email: 'Email Address',
          service: 'Select Service',
          date: 'Preferred Date',
          time: 'Preferred Time',
          notes: 'Additional Notes (Optional)',
          submit: 'Book Appointment',
          submitting: 'Booking...',
          success: 'Appointment booked successfully! We will contact you soon.',
          error: 'Failed to book appointment. Please try again.'
        }
      },
      contact: {
        title: 'Contact Us',
        subtitle: 'Get in touch with Aarogya ENT Clinic',
        form: {
          name: 'Your Name',
          phone: 'Phone Number',
          email: 'Email Address',
          message: 'Your Message',
          submit: 'Send Message',
          submitting: 'Sending...',
          success: 'Message sent successfully! We will get back to you soon.',
          error: 'Failed to send message. Please try again.'
        },
        info: {
          address: 'Aarogya ENT Clinic, Ambari, Pavoi Road, Biswanath Charali, Assam - 784176',
          phone: '03715222367 / 9864815487',
          email: 'aarogyaent@gmail.com',
          hours: 'Mon-Sat: 10:00 AM - 2:00 PM'
        }
      },
      blog: {
        title: 'Health Resources',
        subtitle: 'Latest articles and information about ENT health',
        readMore: 'Read More'
      },
      faq: {
        title: 'Frequently Asked Questions',
        subtitle: 'Common questions about our services and treatments'
      },
      footer: {
        about: 'About Clinic',
        aboutText: 'Aarogya ENT Clinic has been serving the Biswanath community for over 30 years with expert ENT care.',
        quickLinks: 'Quick Links',
        services: 'Services',
        contactInfo: 'Contact Info',
        rights: 'All rights reserved.'
      }
    }
  },
  as: {
    translation: {
      nav: {
        home: 'মূল পৃষ্ঠা',
        about: 'বিষয়ে',
        services: 'সেৱাসমূহ',
        blog: 'ব্লগ',
        contact: 'যোগাযোগ',
        bookAppointment: 'সাক্ষাৎকাৰ বুক কৰক',
        emergency: 'জৰুৰীকালীন'
      },
      hero: {
        welcome: '৩০ বছৰৰ বিশ্বাসযোগ্য ENT সেৱা',
        subtitle: 'বিশ্বনাথ, অসমত কাণ, নাক আৰু ডিঙিৰ ৰোগৰ বিশেষজ্ঞ পৰামৰ্শ',
        cta: 'আপোনাৰ সাক্ষাৎকাৰ বুক কৰক',
        learnMore: 'অধিক জানক'
      },
      about: {
        title: 'ডা. এন.চি. উপাধ্যায়ৰ বিষয়ে',
        subtitle: 'মুখ্য ENT পৰামৰ্শদাতা',
        description: 'ডা. এন.চি. উপাধ্যায়ে অসম চিকিৎসা মহাবিদ্যালয়, ডিব্ৰুগড়ৰ পৰা MBBS আৰু শিলচৰ চিকিৎসা মহাবিদ্যালয়ৰ পৰা DLO লাভ কৰিছে আৰু অটোৰাইনোলেৰিংগোলজীত ৩০ বছৰতকৈও অধিক অভিজ্ঞতা আছে। বিশ্বনাথৰ অৱসৰপ্ৰাপ্ত SDMO আৰু ভাৰতীয় চিকিৎসা সংঘৰ বিশ্বনাথ শাখাৰ সভাপতি হিচাপে, তেওঁ সমাজক সেৱা আগবঢ়াবলৈ আৰোগ্য ENT ক্লিনিক প্ৰতিষ্ঠা কৰিছে।',
        experience: '৩০+ বছৰৰ অভিজ্ঞতা',
        community: 'সমাজক সেৱা',
        expertise: 'বিশেষজ্ঞ ENT সেৱা'
      },
      services: {
        title: 'আমাৰ সেৱাসমূহ',
        subtitle: 'এটা চালৰ তলত সম্পূৰ্ণ ENT সেৱা',
        consultation: {
          title: 'ENT পৰামৰ্শ',
          description: 'সকলো কাণ, নাক আৰু ডিঙিৰ অৱস্থাৰ সম্পূৰ্ণ মূল্যায়ন আৰু নিদান'
        },
        endoscopy: {
          title: 'ENT এণ্ডোস্কপী',
          description: 'ENT ৰোগৰ সঠিক নিদানৰ বাবে উন্নত এণ্ডোস্কপিক পৰীক্ষা'
        },
        waxRemoval: {
          title: 'কাণৰ ম\'ম আঁতৰোৱা',
          description: 'সম্পূৰ্ণ ম\'ম আঁতৰোৱাৰ বাবে সুৰক্ষিত আৰু বিষহীন পদ্ধতি'
        },
        microscope: {
          title: 'মাইক্ৰস্কপিক পৰীক্ষা',
          description: 'সঠিক নিদানৰ বাবে মাইক্ৰস্কপৰ তলত বিস্তৃত পৰীক্ষা'
        },
        foreignBody: {
          title: 'বিদেশী বস্তু আঁতৰোৱা',
          description: 'কাণ, নাক আৰু ডিঙিৰ পৰা বিদেশী বস্তুৰ সুৰক্ষিত আঁতৰোৱা'
        },
        allergyTesting: {
          title: 'এলাৰ্জী পৰীক্ষা',
          description: 'ENT সমস্যা সৃষ্টি কৰা এলাৰ্জেন চিনাক্ত কৰিবলৈ সম্পূৰ্ণ পৰীক্ষা'
        },
        vertigo: {
          title: 'ভাৰ্টিগো মূল্যায়ন',
          description: 'ভাৰ্টিগো আৰু ভাৰসাম্য বিকাৰৰ সম্পূৰ্ণ মূল্যায়ন আৰু চিকিৎসা'
        }
      },
      appointment: {
        title: 'আপোনাৰ সাক্ষাৎকাৰ বুক কৰক',
        subtitle: 'আৰোগ্য ENT ক্লিনিকত আপোনাৰ ভ্ৰমণ নিৰ্ধাৰণ কৰক',
        form: {
          name: 'সম্পূৰ্ণ নাম',
          phone: 'ফোন নম্বৰ',
          email: 'ইমেইল ঠিকনা',
          service: 'সেৱা নিৰ্বাচন কৰক',
          date: 'পছন্দৰ তাৰিখ',
          time: 'পছন্দৰ সময়',
          notes: 'অতিৰিক্ত টোকা (ঐচ্ছিক)',
          submit: 'সাক্ষাৎকাৰ বুক কৰক',
          submitting: 'বুক কৰি আছে...',
          success: 'সাক্ষাৎকাৰ সফলভাৱে বুক কৰা হৈছে! আমি শীঘ্ৰেই আপোনাৰ সৈতে যোগাযোগ কৰিম।',
          error: 'সাক্ষাৎকাৰ বুক কৰিবলৈ বিফল হৈছে। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।'
        }
      },
      contact: {
        title: 'যোগাযোগ কৰক',
        subtitle: 'আৰোগ্য ENT ক্লিনিকৰ সৈতে যোগাযোগ কৰক',
        form: {
          name: 'আপোনাৰ নাম',
          phone: 'ফোন নম্বৰ',
          email: 'ইমেইল ঠিকনা',
          message: 'আপোনাৰ বাৰ্তা',
          submit: 'বাৰ্তা পঠাওক',
          submitting: 'পঠাই আছে...',
          success: 'বাৰ্তা সফলভাৱে পঠোৱা হৈছে! আমি শীঘ্ৰেই আপোনাৰ সৈতে যোগাযোগ কৰিম।',
          error: 'বাৰ্তা পঠাবলৈ বিফল হৈছে। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।'
        },
        info: {
          address: 'আৰোগ্য ENT ক্লিনিক, আম্বাৰী, পাভৈ ৰোড, বিশ্বনাথ চাৰিআলি, অসম - 784176',
          phone: '03715222367 / 9864815487',
          email: 'aarogyaent@gmail.com',
          hours: 'সোম-শনি: ১০:০০ পুৱা - ২:০০ দিন'
        }
      },
      blog: {
        title: 'স্বাস্থ্য সম্পদ',
        subtitle: 'ENT স্বাস্থ্যৰ বিষয়ে শেহতীয়া প্ৰবন্ধ আৰু তথ্য',
        readMore: 'অধিক পঢ়ক'
      },
      faq: {
        title: 'সঘনাই সোধা প্ৰশ্ন',
        subtitle: 'আমাৰ সেৱা আৰু চিকিৎসাৰ বিষয়ে সাধাৰণ প্ৰশ্ন'
      },
      footer: {
        about: 'ক্লিনিকৰ বিষয়ে',
        aboutText: 'আৰোগ্য ENT ক্লিনিকে ৩০ বছৰতকৈও অধিক সময় ধৰি বিশ্বনাথ সমাজক বিশেষজ্ঞ ENT সেৱা আগবঢ়াই আহিছে।',
        quickLinks: 'দ্ৰুত লিংক',
        services: 'সেৱাসমূহ',
        contactInfo: 'যোগাযোগৰ তথ্য',
        rights: 'সকলো স্বত্ব সংৰক্ষিত।'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
